// extracted by mini-css-extract-plugin
export default {"cardFlex":"styles_cardFlex__CSLff"};